"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.more = exports["default"] = void 0;
var more = ["aim.com", "bellatlantic.net", "citlink.net", "compuserve.com", "cs.com", "frontier.com", "frontiernet.net", "games.com", "goowy.com", "gte.net", "love.com", "netscape.net", "rocketmail.com", "rogers.com", "sky.com", "verizon.net", "verizon.net.in", "wild4music.com", "wmconnect.com", "wow.com", "y7mail.com", "ybb.ne.jp", "ygm.com", "ymail.com"];
exports.more = more;
var _default = more;
exports["default"] = _default;